import { useNavigate } from 'react-router-dom';
import { Palette, Plus, Lock as LockIcon } from 'lucide-react';
import PlanGate, { useVoucherLock } from '../../../../components/gating/PlanGate';
import { toast } from 'react-hot-toast';

const VoucherHeader = ({ onOpenCustomizer }) => {
    const navigate = useNavigate();
    const { isLocked: isVoucherLocked } = useVoucherLock();

    const handleCreateClick = () => {
        if (isVoucherLocked) {
            navigate('/subscription');
            toast.error('Your trial or subscription has ended. Upgrade to create vouchers.');
        } else {
            navigate('/create-voucher');
        }
    };

    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
            <div>
                <h1 className="text-xl sm:text-2xl font-black text-[#067978] tracking-tight uppercase">Voucher MANAGEMENT</h1>
                <p className="text-xs sm:text-sm text-slate-500 mt-1">Generate, customise, and track dynamic vouchers for your travellers.</p>
            </div>

            {/* Buttons Container */}
            <div className="flex flex-row items-center gap-2 sm:gap-3 w-full sm:w-auto shrink-0">
                {onOpenCustomizer && (
                    <button
                        type="button"
                        onClick={onOpenCustomizer}
                        className="flex-1 sm:flex-initial flex items-center justify-center gap-1.5 sm:gap-2 bg-white hover:bg-slate-50 text-slate-700 hover:text-[#067978] border border-slate-200 hover:border-[#067978]/40 px-2.5 sm:px-5 py-2.5 rounded-xl font-bold text-xs sm:text-sm shadow-xs transition-all active:scale-95 whitespace-nowrap cursor-pointer"
                    >
                        <Palette size={16} className="text-[#067978] shrink-0" />
                        <span>Voucher Template</span>
                    </button>
                )}

                <PlanGate
                    featureKey="voucher-creation"
                    featureName="Voucher Creation"
                    tooltipText="Subscription required to create vouchers."
                    showLockIcon={false}
                    wrapperClassName="flex-1 sm:flex-initial w-full sm:w-auto"
                >
                    {({ isLocked }) => (
                        <button
                            onClick={handleCreateClick}
                            className="flex-1 sm:flex-initial w-full sm:w-auto px-2.5 sm:px-6 py-2.5 bg-[#067978] text-white rounded-xl text-xs sm:text-sm font-semibold hover:bg-[#056665] shadow-lg shadow-[#067978]/20 transition-all active:scale-95 cursor-pointer flex items-center justify-center gap-1.5 sm:gap-2 whitespace-nowrap"
                        >
                            <Plus size={16} className="shrink-0" />
                            <span>Create Voucher</span>
                            {(isLocked || isVoucherLocked) && <LockIcon size={14} className="ml-1 text-white/90 shrink-0" />}
                        </button>
                    )}
                </PlanGate>
            </div>
        </div>
    );
};

export default VoucherHeader;
